import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MyAccountComponent } from './my-account/my-account.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ThermostatFeatureProfileComponent } from './feature-modules/thermostat-feature-profile/thermostat-feature-profile.component';
import { SceneProfileComponent } from './feature-modules/scene-profile/scene-profile.component';
import { WaterQualityManagerComponent } from './feature-modules/water-quality-manager/water-quality-manager.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: "support-users",
    canMatch: [AuthGuard],
    loadChildren: () => import('./feature-modules/support-users/support-users.module').then(m => m.SupportUsersModule)
  },
  {
    path: "sites",
    canMatch: [AuthGuard],
    loadChildren: () => import('./feature-modules/sites/sites.module').then(m => m.SitesModule)
  },
  {
    path: "equipment",
    canMatch: [AuthGuard],
    loadChildren: () => import('./feature-modules/equipment/equipment.module').then(m => m.EquipmentModule)
  },
  {
    path: "businesses",
    canMatch: [AuthGuard],
    loadChildren: () => import('./feature-modules/businesses/businesses.module').then(m => m.BusinessesModule)
  },
  {
    path: "equipment/thermostat-feature-profile/:id",
    canActivate: [AuthGuard],
    component: ThermostatFeatureProfileComponent
  },
  {
    path: "equipment/scene-feature-profile/:siteId/:sceneId",
    canActivate: [AuthGuard],
    component: SceneProfileComponent
  },
  {
    path: "equipment/water-quality-manager/:id",
    canActivate: [AuthGuard],
    component: WaterQualityManagerComponent
  },
  {
    path: "manage-account-info",
    component: MyAccountComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
